<template>
    <b-card class="mt-3">
        <b-row>
            <b-col>
                <div>{{title}}</div>
                <small>{{description}}</small>
            </b-col>
            <b-col class="text-left text-middle font24pt">
                {{total}}
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
    export default {
        props:['title','description','total'],
        name: "StateTotal"
    }
</script>

<style scoped>
    .font24pt {
        font-size: 24pt;
    }
</style>


// WEBPACK FOOTER //
// src/components/StateTotal.vue